<template>
  <div>
    <InitializeLicenses />
  </div>
</template>

<script>
import InitializeLicenses from '@/nfmp_components/InitializeLicenses.vue'
export default {
  components: {
    InitializeLicenses
  }
}
</script>